<template>
  <div class="user-data">
    <WAvatar
      v-if="showAvatar"
      class="user-data__avatar"
      :url="user.profileImageUrl"
    />
    <div>
      <div class="user-data__name big">
        {{ user.fullName }}
      </div>
      <div class="user-data__codes">
        <span> CPF </span>
        <span class="user-data__value">
          {{ formatCPF(user.nationalId) }}
        </span>
        <span v-if="council">
          {{ council.name }}
        </span>
        <span v-if="council" class="user-data__value">
          {{ council.number }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { WAvatar } from '@alice-health/wonderland-vue'
import { format } from '@fnando/cpf'
import { mapGetters } from 'vuex'
export default {
  components: { WAvatar },
  props: {
    showAvatar: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('user', ['user']),
    council() {
      if (!this.user?.council) return { name: '', number: '' }
      return typeof this.user?.council === 'string'
        ? this.buildCouncilFromString()
        : this.buildCouncilFromObject()
    }
  },
  methods: {
    formatCPF(cpf) {
      return format(cpf)
    },
    buildCouncilFromString() {
      const councilParts = this.user.council?.split(' ')
      if (!councilParts || councilParts.length !== 2) return null
      return {
        name: councilParts[0].replace(':', ''),
        number: councilParts[1]
      }
    },
    buildCouncilFromObject() {
      return {
        name: 'CRM',
        number: `${this.user.council.number}/${this.user.council.state}`
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/style/_non-rendering';
.user-data {
  @extend %body-small;
  display: flex;
  align-items: center;
  margin-bottom: var(--gl-spacing-04);
  color: var(--gl-color-shades-gray-100);
  line-height: var(--gl-line-height-xxs);

  &__name {
    line-height: var(--gl-line-height-xxs);
    &.big {
      font-weight: var(--gl-font-weight-medium);
      font-size: var(--gl-font-size-md);
      margin-bottom: var(--gl-spacing-02);
    }
  }

  &__avatar {
    grid-area: avatar;
    margin-right: var(--gl-spacing-02);
  }

  &__codes {
    span:nth-of-type(2) {
      margin-right: var(--gl-spacing-06);
    }
  }

  &__value {
    color: var(--gl-color-shades-gray-60);
  }
}
</style>
